// Copyright 2024, Imprivata, Inc.  All rights reserved.

import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18nextOptions from './i18nextOptions';

const i18n = i18next.createInstance();
const normalizeLanguage = (lng?: string): string => {
  const supported = i18nextOptions().supportedLngs || [];
  const lang = lng?.split('-')[0];
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  return supported.includes(lang!) ? lang! : 'en';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ...i18nextOptions(),
    load: 'languageOnly',
  })
  .then(() => {
    const normalized = normalizeLanguage(i18n.language);

    if (i18n.language !== normalized) {
      i18n.changeLanguage(normalized);
    }
  })
  .catch(err => err);

export default i18n;